import { Box, Typography } from '@mui/material';
import { ShoppingCart, Leaf, QrCode } from 'lucide-react';

const steps = [
  {
    icon: ShoppingCart,
    title: 'Eliges con intención',
    description: 'Exploras productos creados con conciencia ambiental y propósito real.',
  },
  {
    icon: Leaf,
    title: 'Tu compra activa un proyecto en Chile',
    description: 'Cada producto financia directamente una iniciativa ambiental concreta y verificable.',
  },
  {
    icon: QrCode,
    title: 'Ves el impacto que ayudaste a crear',
    description: 'Escaneando el código QR de tu compra, accedes a avances, resultados y evolución del proyecto que apoyaste.',
  },
];

function HowItWorks() {
  return (
    <Box
      id="como-funciona"
      sx={{
        mt: { xs: 8, sm: 10, md: 12 },
        mb: { xs: 3, sm: 4 },
        width: '100%',
        maxWidth: { xs: '100%', sm: '650px', md: '700px' },
        mx: 'auto',
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: 'text.primary',
          mb: { xs: 6, sm: 8, md: 10 },
          fontSize: { xs: '1.5rem', sm: '1.75rem', md: '2rem' },
          fontWeight: 600,
          textAlign: 'center',
          px: { xs: 2, sm: 0 },
        }}
      >
        Cómo transformas tu compra en impacto real
      </Typography>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
          gap: { xs: 5, md: 4 },
          px: { xs: 2, sm: 0 },
          maxWidth: { xs: '100%', md: '900px' },
          mx: 'auto',
        }}
      >
        {steps.map((step, index) => {
          const IconComponent = step.icon;
          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  mb: { xs: 2, sm: 2.5 },
                }}
              >
                <IconComponent size={32} color="#4a6a4a" />
              </Box>
              <Typography
                variant="h6"
                sx={{
                  color: 'text.primary',
                  fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.4rem' },
                  fontWeight: 600,
                  textAlign: 'center',
                  mb: { xs: 1.5, sm: 2 },
                  lineHeight: 1.3,
                }}
              >
                {step.title}
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  fontSize: { xs: '0.9rem', sm: '0.95rem', md: '1rem' },
                  fontWeight: 400,
                  lineHeight: 1.6,
                  textAlign: 'center',
                  maxWidth: '280px',
                }}
              >
                {step.description}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
}

export default HowItWorks;

